/* eslint-disable */

/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '../routes';
import store from "../store";

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('access_token');
    if (token === null) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      });
    } else {
      let decode = Vue.jwtDec.decode(token);
      let currentTime = Date.now() / 1000;
      if (decode.exp < currentTime) {
        localStorage.removeItem('access_token');
        next({
          name: 'Login',
          query: { redirect: to.fullPath }
        });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});



Vue.router = router;
